import { Timestamp } from "firebase/firestore";
import { OrganizationSettings, OrganizationStatus } from "./organizations";

export type UID = string;

export enum ProfileType {
  ADMIN = "ADMIN",
  DEFAULT = "DEFAULT",
  LEADEARSHIP = "LEADEARSHIP",
}

export enum InviteStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  LOCKED = "LOCKED",
}

export type UserSettings = Pick<
  AppUser,
  "firstName" | "title" | "email" | "profile" | "phoneNumber"
>;

export interface AppUser extends OrganizationSettings {
  uid: UID;
  email: string;
  emailVerified?: boolean;
  firstName?: string;
  lastName?: string;
  title?: string;
  phoneNumber?: string;
  organizationId?: string;
  organizationName?: string;
  organizationStatus?: OrganizationStatus;
  isOutreachAuthorized?: boolean;
  isHubSpotAuthorized?: boolean;
  isProspectWebhookCreated?: boolean;
  profile?: ProfileType;
  role?: string;
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
  outreachOrganizationId?: string;
  // The CRM the person signed up for (the sign-up page's look, from the
  // website's ?crm=); the backend starts their organization on it.
  signupCrm?: "hubspot" | "outreach";
  // Set by the backend when signup matched an existing organization (invite or
  // email domain); the join waits until the user verifies their email.
  pendingOrgJoin?: boolean;
  pendingOrgCreation?: boolean; // Flag to skip org creation during signup - org will be created/assigned after Outreach auth
}

export interface OrgDisplayUser {
  uid?: UID;
  firstName?: string;
  lastName?: string;
  email: string;
  isSelf?: boolean;
  isUserCreated?: boolean;
  inviteStatus?: InviteStatus;
  isDisabled?: boolean;
}

export interface OutreachUser {
  id: number;
  type: string;
  attributes: {
    email: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    avatarUrl?: string;
    locked?: boolean;
    active?: boolean;
  };
  links?: {
    self: string;
  };
  relationships?: {
    role?: {
      data: {
        id: string;
        type: string;
      };
    };
    teams?: {
      data: Array<{
        id: string;
        type: string;
      }>;
    };
    profile?: {
      data: {
        id: string;
        type: string;
      };
    };
  };
}

export interface OutreachDisplayUser {
  id: number;
  email: string;
  firstName?: string;
  lastName?: string;
  fullName: string;
  avatarUrl?: string;
  isActive: boolean;
  isWhitelisted: boolean;
  role?: string;
  teams?: string[];
}

export interface HubSpotUserTeam {
  id: string;
  name: string;
  primary: boolean;
}

export interface HubSpotUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  userId?: number;
  teams?: HubSpotUserTeam[];
  archived?: boolean;
  createdAt?: string;
  updatedAt?: string;
  // From Settings Users API
  roleId?: string;
  roleName?: string;
  avatarUrl?: string;
  superAdmin?: boolean;
}

export interface HubSpotDisplayUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  fullName: string;
  isWhitelisted: boolean;
}
